module.exports = __webpack_public_path__ + "img/MoMobil2.474177fb.png";